module.exports = __webpack_public_path__ + "img/breather-pic.c7d6e4fd.jpg";